class ServicoUsuarioInstitucional {
    constructor({ api }) {
        this.api = api;
    }

    obterUsuariosInstitucionais() {
        return this.api
            .get("/api/admin/usuarios-institucionais")
            .then((response) => response.data);
    }

    obterMeusUsuariosInstitucionais() {
        return this.api
            .get(`/api/usuarios-institucionais/meus`)
            .then((response) => response.data);
    }

    usuarioInstitucionalExiste(nome) {
        return this.obterUsuarioInstitucionalPorNome(nome).then(
            (usuariosInstitucionais) => {
                return usuariosInstitucionais.length > 0;
            },
        );
    }

    obterUsuarioInstitucionalPorId(id) {
        return this.api
            .get(`/api/admin/usuarios-institucionais/${id}`)
            .then((response) => response.data);
    }

    obterUsuarioInstitucionalPorNome(nome) {
        return this.api
            .get(
                `/api/admin/usuarios-institucionais/busca?nome=${encodeURIComponent(
                    nome,
                )}`,
            )
            .then((response) => {
                return response.data;
            });
    }

    salvarUsuarioInstitucional(usuarioInstitucional) {
        if (usuarioInstitucional.id) {
            return this.api
                .put(
                    `/api/admin/usuarios-institucionais/${usuarioInstitucional.id}`,
                    usuarioInstitucional,
                )
                .then((response) => response.data);
        }
        return this.api
            .post("/api/admin/usuarios-institucionais", usuarioInstitucional)
            .then((response) => response.data);
    }

    apagarUsuarioInstitucional(usuarioInstitucional) {
        return this.api
            .delete(
                `/api/admin/usuarios-institucionais/${usuarioInstitucional.id}`,
            )
            .then((response) => response.data);
    }
}

export default ServicoUsuarioInstitucional;
